"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VehicleDropOffServiceItemDto = void 0;
class VehicleDropOffServiceItemDto {
    constructor(params) {
        if (!params) {
            return;
        }
        this.id = params.id;
        this.vehicleDropOffId = params.vehicleDropOffId;
        this.name = params.name;
        this.desc = params.desc;
        this.itemStatus = params.itemStatus;
        this.price = params.price;
        this.accepted = params.accepted;
        this.createdAt = params.createdAt;
        this.updatedAt = params.updatedAt;
    }
}
exports.VehicleDropOffServiceItemDto = VehicleDropOffServiceItemDto;
//# sourceMappingURL=VehicleDropOffServiceItemDto.js.map